import Axios from '@/api/http'

/**
 * 获取个人信息导航列表
 * */
export function openapiGetselfinformation(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getselfinformation',
    data: query
  })
}

/**
 * 删除关联表格信息
 * */
export function apiDeleteapproving(query) {
  return Axios({
    method: 'post',
    url: '/api/deleteapproving',
    data: query
  })
}
/**
 * 获取个人档案信息
 * */
export function getmyinformation(query) {
  return Axios({
    method: 'post',
    url: '/api/getmyinformation',
    data: query
  })
}
/**
 * 修改个人档案信息
 * */
export function updatemyinformation(query) {
  return Axios({
    method: 'post',
    url: '/api/updatemyinformation',
    data: query
  })
}
/**
 * 获取显示信息
 * */
export function openapiGetuserapprovinglist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserapprovinglist',
    data: query
  })
}
/**
 * 获取用户统计数量
 * */
export function wlogs(query) {
  return Axios({
    method: 'post',
    url: '/api/wlogs',
    data: query
  })
}
/**
 * 获取用户角色
 * */
export function getuserlevel(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserlevel',
    data: query
  })
}
/**
 * 个人空间数据统计监管
 * */
export function getupacecount(query) {
  return Axios({
    method: 'post',
    url: '/api/getupacecount',
    data: query
  })
}
/**
 * 组织空间数据统计监管
 * */
export function getspacecount(query) {
  return Axios({
    method: 'post',
    url: '/api/getspacecount',
    data: query
  })
}
